import api from '@/services/api'

export default {
  getAll(page, term, company, cart, atacarejo) {
    let url = `/products?page=${page}&term=${term}&company=${company}&cart=${cart}`;

    if (atacarejo) {
      url += '&atacarejo=T';
    }
    return api.get(url)
  },

  getList(page, term, company) {
    let url = `/products/list?page=${page}&term=${term}&company=${company}`;
    return api.get(url)
  },

  getPrices(page, company, customer) {
    return api.get(`/products/prices?page=${page}&companyId=${company}&customerId=${customer}`)
  },

  getAtacarejoPrices(page, customer) {
    return api.get(`/products/prices?page=${page}&customerId=${customer}&atacarejo=true`)
  },

  exportPricesAtacarejo(customer) {
    return api({
      url: `/products/prices?export=true&customerId=${customer}&atacarejo=true`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getStock(page, term = '', company) {
    return api.get(`/products/stock?page=${page}&term=${term}&company=${company}`)
  },

  exportPrices(company, customer) {
    return api({
      url: `/products/prices?export=true&companyId=${company}&customerId=${customer}`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  exportStock(term, company) {
    return api({
      url: `/products/stock?export=true&term=${term}&company=${company}`,
      method: 'GET',
      responseType: 'blob',
    })
  },
}